import {
  PolicyActionWithResource,
  WorkspacePolicyData,
  WorkspaceResourceData,
} from './types';

export const connectorAttributeCheck: PolicyActionWithResource<
  WorkspaceResourceData['connector']['create'],
  WorkspacePolicyData
> = (_, constraints, resource) =>
  constraints.organization_available_connectors.split(',').includes(resource.connectorId);
